<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.60291 1.70548C7.84882 1.56495 8.15092 1.56499 8.39685 1.70548L13.9974 4.90568C14.3807 5.125 14.5134 5.61304 14.2943 5.9965C14.1468 6.25472 14 6.40021 13.6 6.80021L12.0004 8.3588V7.99943C12.0001 7.55781 11.6413 7.19962 11.1996 7.19962C10.7581 7.19985 10.4 7.55796 10.3998 7.99943V9.91837L6.62244 13.6H2.39978C1.95816 13.5999 1.60014 13.2418 1.59998 12.8002C1.59998 12.3585 1.95806 11.9995 2.39978 11.9994V6.39982C2.12244 6.39943 1.85291 6.25456 1.70544 5.9965C1.48649 5.61296 1.61987 5.12486 2.0033 4.90568L7.60291 1.70548ZM4.80017 7.19962C4.3585 7.19962 4.00062 7.55781 4.00037 7.99943V10.3998C4.00037 10.8416 4.35834 11.1996 4.80017 11.1996C5.24193 11.1995 5.59998 10.8416 5.59998 10.3998V7.99943C5.59972 7.55787 5.24177 7.19971 4.80017 7.19962ZM8.00037 7.19962C7.55869 7.19962 7.19984 7.55781 7.19958 7.99943V10.3998C7.19958 10.8416 7.55854 11.1996 8.00037 11.1996C8.44203 11.1994 8.80017 10.8415 8.80017 10.3998V7.99943C8.79992 7.55793 8.44187 7.19981 8.00037 7.19962Z" fill="currentColor"/>
    <path d="M14.0489 8.33474C14.4952 7.88842 15.2188 7.88842 15.6651 8.33474C16.1115 8.78105 16.1115 9.50467 15.6651 9.95098L15.2121 10.4041L13.5958 8.78782L14.0489 8.33474Z" fill="currentColor"/>
    <path d="M12.7877 9.59594L7.99988 14.3838V16H9.61612L14.4039 11.2122L12.7877 9.59594Z" fill="currentColor"/>
  </svg>
</template>

<script setup lang="ts">

</script>
